import { useEffect, useState } from "react";
import { MUC_DO } from "@shared/nhanXetDeck.js";

/**
 * "Ví dụ báo cáo nhận xét" ở đầu /nhan-xet-deck: mô phỏng đúng cấu trúc báo cáo
 * thật (KetQuaNhanXet) để founder thấy trước mình nhận được gì. Ba màn tự
 * chuyển: Tổng quan → Việc sửa trước → Từng slide (viết lại). Chạm thẻ để chọn
 * màn (dừng tự chạy). Mọi số liệu là VÍ DỤ, có ghi rõ trên khung.
 * HTML prerender là màn Tổng quan đầy đủ.
 */
const MAN = ["Tổng quan", "Việc sửa trước", "Từng slide"];
const DIEM = 64;
const TRUC = [["Vấn đề và giải pháp", 4], ["Thị trường", 3], ["Bằng chứng (traction)", 2], ["Đội ngũ", 4], ["Tài chính và số vốn gọi", 2]];
const UU_TIEN = [
  ["Đưa số liệu khách hàng thật lên đầu deck", "Slide 3", "Cao"],
  ["Ghi rõ số vốn gọi và dùng vào việc gì", "Slide 11", "Cao"],
  ["Thu hẹp thị trường về nhóm khách mua được ngay", "Slide 5", "Vừa"],
];

export default function NhanXetMau() {
  const [man, setMan] = useState(0);
  const [chay, setChay] = useState(false);
  const [so, setSo] = useState(DIEM);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    setChay(true);
  }, []);
  useEffect(() => {
    if (!chay) return undefined;
    const id = setTimeout(() => { if (!document.hidden) setMan((m) => (m + 1) % MAN.length); }, man === 2 ? 5200 : 4200);
    return () => clearTimeout(id);
  }, [chay, man]);
  // Điểm đếm từ 0 lên mỗi lần vào màn Tổng quan.
  useEffect(() => {
    if (man !== 0 || !chay) return undefined;
    setSo(0);
    let x = 0;
    const id = setInterval(() => { x = Math.min(DIEM, x + 4); setSo(x); if (x >= DIEM) clearInterval(id); }, 30);
    return () => clearInterval(id);
  }, [man, chay]);

  return (
    <div className="nxm">
      <div className="nxm-tren">
        <span>Ví dụ báo cáo nhận xét</span>
        <span className="nxm-deck">Deck 12 slide</span>
      </div>
      <div className="nxm-tab" role="tablist" aria-label="Các phần của báo cáo">
        {MAN.map((t, i) => (
          <button key={t} type="button" role="tab" aria-selected={i === man} className={i === man ? "dang" : ""}
            onClick={() => { setChay(false); setSo(DIEM); setMan(i); }}>{t}</button>
        ))}
      </div>

      <div className="nxm-man" key={man}>
        {man === 0 && (
          <div className="nxm-tong">
            <div className="nxm-diem">
              <b>{so}</b><span>/100</span>
              <p>{MUC_DO["can-sua-nhieu"]}</p>
              <ul>
                <li className="do"><strong>2</strong> nghiêm trọng</li>
                <li className="vang"><strong>3</strong> cần sửa</li>
                <li className="xanh"><strong>7</strong> ổn</li>
              </ul>
            </div>
            <ul className="nxm-truc" aria-label="Điểm theo từng phần">
              {TRUC.map(([ten, d], i) => (
                <li key={ten} style={{ "--i": i }}>
                  <span>{ten}</span>
                  <i aria-hidden="true">{[1, 2, 3, 4, 5].map((k) => <em key={k} className={k <= d ? `day d${d}` : ""} />)}</i>
                  <b>{d}/5</b>
                </li>
              ))}
            </ul>
          </div>
        )}
        {man === 1 && (
          <ol className="nxm-uu">
            {UU_TIEN.map(([viec, slide, muc], i) => (
              <li key={viec} style={{ "--i": i }}>
                <span className="nxm-uu-so">{i + 1}</span>
                <span className="nxm-uu-viec">{viec}<small>{slide}</small></span>
                <span className={`nxm-uu-muc ${muc === "Cao" ? "cao" : ""}`}>Ảnh hưởng {muc.toLowerCase()}</span>
              </li>
            ))}
          </ol>
        )}
        {man === 2 && (
          <div className="nxm-slide">
            <div className="nxm-slide-the" aria-hidden="true">
              <span>SLIDE 3</span>
              <i /><i /><i className="ngan" />
            </div>
            <div className="nxm-viet">
              <p className="nxm-nhan">Slide 3: Bằng chứng</p>
              <p className="nxm-cu"><small>Hiện tại</small><s>“Nhiều khách hàng yêu thích sản phẩm của chúng tôi.”</s></p>
              <p className="nxm-moi"><small>Gợi ý viết lại</small>“1.200 cửa hàng dùng thử, 38% trả phí sau 2 tháng.”</p>
              <p className="nxm-ly">Nhà đầu tư cần con số kiểm chứng được, không cần tính từ.</p>
            </div>
          </div>
        )}
      </div>
      <p className="nxm-chan">Kèm theo: nhận xét đủ 12 slide, 8 câu hỏi nhà đầu tư sẽ hỏi</p>
    </div>
  );
}
